<template>
    <b-card no-body>
        <b-tabs v-model="activeTab" pills nav-class="pt-1 px-1" active-nav-item-class="nav-pill-secondary" content-class="border-top">
            <b-tab title="Personeller" active>
                <v-table   	ref="table"
                            :add-callback="createNew"
                            :fields="fields"
                            :buttons="buttons"
                            pagination = "server"
                            name="employee-table"
                            :excel-callback="getExcel"
                            search
                            button-alignment="justify-content-center"
                            :items-provider="provider">
                                <template #filters>
                                    <employee-filter v-on:filter="filter" ref="filter"></employee-filter>
                                </template>
                        </v-table>
            </b-tab>
            <b-tab title="Adaylar">
                <div class="p-1">
                    <div class="d-flex align-items-center mb-1">
                        <b-form-checkbox v-model="includeConverted" class="mr-1" v-on:change="getCandidates" switch>
                            Dönüştürülenleri de göster
                        </b-form-checkbox>
                    </div>
                    <b-overlay :show="candidatesLoading" opacity="0.2" rounded="sm">
                        <b-table
                            :items="candidates"
                            :fields="candidateFields"
                            responsive
                            striped
                            hover
                            show-empty
                            empty-text="Aday personel kaydı bulunamadı."
                            small
                        >
                            <template #cell(CompletedStep)="data">
                                <b-badge variant="light-secondary">{{ data.item.CompletedStep }}/7. Adım</b-badge>
                            </template>
                            <template #cell(CreateTime)="data">
                                {{ formatDate(data.item.CreateTime) }}
                            </template>
                            <template #cell(actions)="data">
                                <div class="d-flex justify-content-end">
                                    <button v-if="data.item.IsConverted" class="btn btn-primary btn-sm" v-on:click="goToEmployee(data.item)" title="Personele Git" :disabled="!data.item.ConvertedEmployeeId">
                                        <feather-icon icon="UserIcon" class="mr-25"></feather-icon>
                                        Personele Git
                                    </button>
                                    <template v-else>
                                        <button class="btn btn-secondary btn-sm mr-50" v-on:click="editCandidate(data.item)" title="Düzenle">
                                            <feather-icon icon="Edit2Icon"></feather-icon>
                                        </button>
                                        <button class="btn btn-success btn-sm mr-50" v-on:click="convertCandidate(data.item)" title="Personele Dönüştür" :disabled="convertingId === data.item.Id">
                                            <feather-icon icon="UserCheckIcon"></feather-icon>
                                        </button>
                                        <button class="btn btn-danger btn-sm" v-on:click="removeCandidate(data.item)" title="Sil">
                                            <feather-icon icon="TrashIcon"></feather-icon>
                                        </button>
                                    </template>
                                </div>
                            </template>
                        </b-table>
                    </b-overlay>
                </div>
            </b-tab>
        </b-tabs>
    </b-card>
</template>

<script>
import {BCard,BDropdown,BTabs,BTab,BTable,BBadge,BOverlay,BFormCheckbox} from 'bootstrap-vue'
import EmployeeOperationsApi from '@/api/employee-operations'
import EmployeeFilter from './components/EmployeeFilter.vue'
import moment from 'moment'

export default {
    components:{
        BCard,
        BDropdown,
        EmployeeFilter,
        BTabs,
        BTab,
        BTable,
        BBadge,
        BOverlay,
        BFormCheckbox,
    },
    data(){
        return{
            activeTab:0,
            fields:[
                {name:"Fotoğraf",key:"File",img:true,imgOptions:{class:"rounded-circle",placeholder:require('@/assets/images/avatars/no-user-pic.svg')}},
                {name:"Sicil No",key:"RegistrationCode",thClass:"w-20",sortable:true},
                {name:"Ad Soyad",key:"FullName",thClass:"w-20",sortable:true},
                {name:"Şube",key:"BranchName",sortKey:'LastEmployeeBranch.ActiveBranch.Name',thClass:"w-20",sortable:true},
                {name:"Unvan",key:"EmployeeDepartmentTitleName",sortKey:'LastEmployeeBranch.EmployeeDepartmentTitle.Name',thClass:"w-20",tdClass:'text-nowrap',sortable:true},
                {name:"Cinsiyet",sortable:true,sortKey:'Gender',thClass:'w-20', component:true,componentOptions:{name:"employee-gender/EmployeeGender"}},
            ],
            buttons:[
                { text:"Yeni Sekmede Düzenle",key:"edit",icon:"ExternalLinkIcon",variant:"primary",action:this.newTab },
                { text:"Düzenle",key:"edit",icon:"Edit2Icon",variant:"secondary",action:this.edit },
                { text:"Sil",key:"delete",icon:"TrashIcon",variant:"danger",action:this.delete },
                // { text:"Netsis Eksik Veri Bilgisi",key:"netsisMissingInformation",icon:"DangerIcon",variant:"warning",action:this.netsisMissingInformation },
            ],
            filterData:{
				BranchId:null,
                EmployeeDepartmentTitleId:null,
                JobExit:false,
                IsIntegratedNetsis:null,
                IsEksikVeriNetsis:null
			},
            searchParam:"",
            candidates:[],
            candidatesLoading:false,
            candidatesLoaded:false,
            includeConverted:false,
            convertingId:null,
            candidateFields:[
                { key:"IdentityNumber", label:"T.C. Kimlik No" },
                { key:"FullName", label:"Ad Soyad" },
                { key:"CompletedStep", label:"Durum" },
                { key:"CreateTime", label:"Oluşturulma" },
                { key:"actions", label:"İşlemler", thClass:"text-right", tdClass:"text-right" },
            ],
        }
    },
    watch:{
        activeTab(val){
            if(val === 1 && !this.candidatesLoaded){
                this.getCandidates()
            }
        }
    },
    created(){
        // const gq = (key) => this.$route.query[key] != null ? this.$route.query[key] : null
        // this.filterData.BranchId = gq('bid')
        // this.filterData.EmployeeDepartmentTitleId = gq('edtid')
        // this.filterData.JobExit = gq('je') == null ? null : gq('je') == 'false' ? false : true
        // this.filterData.IsIntegratedNetsis = !!gq('iin')
        // this.filterData.IsEksikVeriNetsis = !!gq('ievn')
    },
    mounted(){
        this.$refs.filter.setFilterData(this.filterData)
        if(this.$route.query?.tab === 'candidates'){
            this.activeTab = 1
        }
    },
    methods:{
        createNew(){
            this.$router.push({name:'candidate-employee-create-or-update',params:{id:0}})
        },
        edit(item){
            this.$router.push({name:'employee-create-or-update',params:{id:item.Id}})
        },
        provider(data){
            this.searchParam = data.QueryParam
            // this.$router.push({ path:this.$route.path, query:{
            //     ...this.$route.query,
            //     search:this.searchParam
            // }})
            return EmployeeOperationsApi.Employee.Table({PaginationRequestModel:data,...this.filterData})
        },
        getExcel(){
            this.$refs.table.setExcelLoading(true)
            EmployeeOperationsApi.Employee.TableExcel({
                ...this.filterData,
                SearchParam:this.searchParam
            }).then(res=>{
                this.$refs.table.setExcelLoading(false)
                this.$result(res)
            }).catch(err=>{
                this.$refs.table.setExcelLoading(false)
                this.$result(null,err)
            })
        },
        filter(filter){
            this.filterData = filter
            this.$refs.table.refresh()
            this.$router.push({ path:this.$route.path, query:{
                ...(filter.BranchId &&  {'bid':filter.BranchId}),
                ...(filter.EmployeeDepartmentTitleId &&  {'edtid':filter.EmployeeDepartmentTitleId}),
                ...((filter.JobExit == true || filter.JobExit == false) && {'je':filter.JobExit}),
                ...(filter.IsIntegratedNetsis &&  {'iin':filter.IsIntegratedNetsis}),
                ...(filter.IsEksikVeriNetsis &&  {'ievn':filter.IsEksikVeriNetsis}),
            } })
        },
        newTab(item){
            let route = this.$router.resolve({ name:'employee-create-or-update', params:{id:item.Id}})
            window.open(route.href, "_blank")
        },
        delete(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FullName} isimli personeli sistemden tamamen silecektir ve geri alınamaz.`).then(c => {
                if(c){
                    EmployeeOperationsApi.Employee.Delete(item.Id).then(res => {
                        if(res.data.Success){
                            this.$refs.table.refresh()
                        }
                        this.$result(res)
                    }).catch(err => {
                        this.$result(null,err)
                    })
                }
            })
        },
        getCandidates(){
            this.candidatesLoading = true
            EmployeeOperationsApi.Employee.Candidate.List(this.includeConverted).then(res=>{
                this.candidatesLoading = false
                this.candidatesLoaded = true
                if(res.data.Success){
                    this.candidates = res.data.Data || []
                }else{
                    this.$result(res)
                }
            }).catch(err=>{
                this.candidatesLoading = false
                this.$result(null,err)
            })
        },
        editCandidate(item){
            this.$router.push({name:'candidate-employee-create-or-update',params:{id:item.Id}})
        },
        goToEmployee(item){
            if(!item.ConvertedEmployeeId) return
            this.$router.push({name:'employee-create-or-update',params:{id:item.ConvertedEmployeeId}})
        },
        convertCandidate(item){
            this.$confirm('Gerçek personele dönüştürülsün mü?',`${item.FullName || 'Bu aday'} gerçek personele dönüştürülecek ve artık aday listesinde düzenlenemeyecektir.`).then(c=>{
                if(!c) return
                this.convertingId = item.Id
                EmployeeOperationsApi.Employee.Candidate.Convert(item.Id).then(res=>{
                    this.$result(res)
                    this.convertingId = null
                    if(res.data.Success){
                        if(res.data.Data && res.data.Data.Id){
                            this.$router.push({name:'employee-create-or-update',params:{id:res.data.Data.Id}})
                        }else{
                            this.getCandidates()
                        }
                    }
                }).catch(err=>{
                    this.convertingId = null
                    this.$result(null,err)
                })
            })
        },
        removeCandidate(item){
            this.$confirm('Silmek istediğinize emin misiniz?',`Bu işlem ${item.FullName || 'aday personeli'} kaydını silecektir.`).then(c=>{
                if(!c) return
                EmployeeOperationsApi.Employee.Candidate.Delete(item.Id).then(res=>{
                    this.$result(res)
                    if(res.data.Success){
                        this.getCandidates()
                    }
                }).catch(err=>{
                    this.$result(null,err)
                })
            })
        },
        formatDate(date){
            return date ? moment(date).format('DD.MM.YYYY HH:mm') : ''
        },
    },
}
</script>

<style>

</style>
